import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { LeadService } from "../../../../services/LeadService";
import { downloadBlob, generateCSV } from "../../../../util/DownloadUtils";
import { ItemType } from "../../../../util/hooks/useCatalog";
import { ChangeAlertCallbackType } from "../../../Root";
import { FilterLeadType } from "../types";

moment.locale('es');

const columnsReport = [
    "Fecha",
    "Correo de registro",
    "Razón Social",
    "Tipo",
    "RFC",
    "Estatus",
    "Responsable",
    "Días transcurridos"
]

export const useDownloadLead = (changeAlert: ChangeAlertCallbackType, status: ItemType[]) => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState<FilterLeadType>();
    const leadService = useRef<LeadService>();

    const getData = async (newFilters?: FilterLeadType) => {
        setLoading(true);

        const response = await leadService.current.getLeadsByFilters({
            filters: {
                ...(newFilters || filters),
                is_download: true
            },

        })

        generateReport(response.data?.content?.leads || [])
        setLoading(false);
    };

    const formatLeadsData = (leads) => {
        const dictionaryStatus = Object.fromEntries(status.map(d => [d.name, d.metadata?.description]));
        const formatedData = leads.map(row => {
            return [
                moment(row.cdate).format("L"),
                row.email,
                row.social_reason,
                row.type,
                row.tax_id,
                dictionaryStatus[row.status] || "",
                row.responsible,
                row.days_update,
            ]
        })
        return formatedData
    }

    const downloadReport = async (newFilters: FilterLeadType) => {
        setFilters(newFilters);
        getData(newFilters)
    }

    const generateReport = (leads) => {
        const formatedData = formatLeadsData(leads)
        const csv = generateCSV(
            columnsReport, formatedData
        )
        const fdesde = moment(filters.dates.start).utc().format("DDMMYYYY")
        const fhasta = moment(filters.dates.end).utc().format("DDMMYYYY")
        const nameReport = `Reporte_de_leads_aFB_${fdesde}_${fhasta}.csv`
        downloadBlob(csv, nameReport, 'text/csv;charset=utf-8;')
    }

    useEffect(() => {
        leadService.current = new LeadService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading, downloadReport, setFilters, filters }
}
